import { useAuth } from "react-oidc-context";

export interface Me {
    email: string | undefined;
    /** Display name for avatars ("Hemant Kumar"), falling back to the email. */
    name: string;
}

/** The signed-in user, from the OIDC profile. */
export function useMe(): Me {
    const profile = useAuth().user?.profile;
    const email = profile?.email ?? undefined;
    return { email, name: profile?.name ?? profile?.preferred_username ?? email ?? "Me" };
}
